import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@topconagriculture/react-components';
import { useStyles } from './styles';
import { formatDate, formatNumberByRegion, getDateFormat, toFarmTimeZone } from '../../../../../utils/utils';
import { useDashboardConfig } from '../../../../../hooks';
import { useRedirect } from '../../../../../hooks/useRedirect';
import cl from 'classnames';
import { useFarmParams } from '../../useFarmParams';
const OrderedIngredientCells = ({ orderDate, confirmDelivery }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { data } = useFarmParams();
    const dateFormat = getDateFormat();
    const date = orderDate && data ? formatDate(toFarmTimeZone(new Date(orderDate), data.timeZone), dateFormat) : '';
    const orderedOnTitle = `${t('widget:ordered_on')} ${date}`;
    const confirmDeliveryTitle = t('widget:confirm_delivery');
    return (React.createElement(React.Fragment, null,
        React.createElement("td", { className: cl(classes.status, classes.alignLeft) },
            React.createElement(Text, { title: orderedOnTitle }, orderedOnTitle)),
        React.createElement("td", null,
            React.createElement(Text, { title: confirmDeliveryTitle.toUpperCase(), onClick: confirmDelivery, className: classes.action }, confirmDeliveryTitle))));
};
const NotOrderedIngredientCells = (props) => {
    const { orderControl, orderIngredient, deliverIngredient } = props;
    const classes = useStyles();
    const { t } = useTranslation();
    const orderTitle = t('widget:order');
    const deliveryTitle = t('widget:delivery');
    return (React.createElement(React.Fragment, null,
        React.createElement("td", null, orderControl && (React.createElement(React.Fragment, null,
            React.createElement(Text, { title: orderTitle.toUpperCase(), className: classes.action, onClick: orderIngredient }, t('widget:order')),
            React.createElement("span", null, " / "),
            React.createElement(Text, { title: deliveryTitle.toUpperCase(), className: classes.action, onClick: deliverIngredient }, t('widget:delivery'))))),
        React.createElement("td", null)));
};
const DeliveryDelay = () => {
    const { t } = useTranslation();
    const { RESOURCES_BASE_URL } = useDashboardConfig();
    const title = t('widget:delivery_delay');
    return (React.createElement(Text, { title: title },
        React.createElement("img", { width: 22, height: 17, src: `${RESOURCES_BASE_URL}/assets/images/dashboard/icons/alert_high.svg`, alt: "Alert high" }),
        ` ${t('widget:delivery_delay')}`));
};
export const InventoryWidgetTableRow = (props) => {
    const { id, description, deliveryDelay, stockDaysLeft, stockPerc, orderDate, orderControl } = props;
    const goToIngredientPage = useRedirect(`/products/ingredients/inventory?ingredient=${id}`);
    const orderIngredient = useRedirect(`/inventory/order-ingredients/create?ingredient=${id}`);
    const deliverIngredient = useRedirect(`/inventory/transactions/create?ingredient=${id}`);
    const percentage = formatNumberByRegion(stockPerc, 2).toString();
    const classes = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            React.createElement("td", { className: classes.description },
                React.createElement(Text, { title: description, onClick: goToIngredientPage }, description)),
            React.createElement("td", { className: cl(classes.delay, classes.alignLeft) }, deliveryDelay && React.createElement(DeliveryDelay, null)),
            React.createElement("td", { className: classes.alignRight },
                React.createElement(Text, { title: stockDaysLeft.toString() }, stockDaysLeft.toString())),
            React.createElement("td", { className: classes.alignRight },
                React.createElement(Text, { title: `${percentage}%` }, `${percentage}%`)),
            orderDate ? (React.createElement(OrderedIngredientCells, { orderDate: orderDate, confirmDelivery: goToIngredientPage })) : (React.createElement(NotOrderedIngredientCells, { orderControl: orderControl, orderIngredient: orderIngredient, deliverIngredient: deliverIngredient })))));
};
//# sourceMappingURL=InventoryWidgetTableRow.js.map